<script lang="ts" type="module">
	import { onMount } from "svelte";
	import { redirectTo, scrollToAnchor } from "../js/common";
	import CardsComponent from "../components/Cards.svelte";
	import LetterComponentPrimary from "../components/LetterPrimary.svelte";
	import LetterComponentSecondary from "../components/LetterSecondary.svelte";
	import type { Card } from "../models/card";
	import type { Page } from "../models/page";
	import { english, square, deglingos, minitel } from "../store/store";
	import MinitelContact from "../components/MinitelContact.svelte";
	import Toaster from "../components/Toaster.svelte";
    import { idPageOu, idPageProjets } from "../components/router/router";

	export let anchor: string = "";

	const cardWebSiteEN: Card = {
		title: "Showcase site",
		description: [
			"Static website",
			"Allows you to give an identity and visibility to your activity",
			"A website is a guarantee of seriousness",
		],
	};

	const cardWebSite: Card = {
		title: "Site vitrine",
		description: [
			"Site web statique",
			"Permet de donner une identité et de la visibilité à votre activité",
			"Un site web est un gage de sérieux",
		],
	};

	const cardECommerceEN: Card = {
		title: "e-Commerce",
		description: [
			"Craftsman, creator, artist, association, company ...",
			"Display your catalog and offer your items for sale online",
		],
	};

	const cardECommerce: Card = {
		title: "Commerce en ligne",
		description: [
			"Artisan, créateur, artiste, association, entreprise ...",
			"Exposez votre catalogue et proposez vos articles à la vente en ligne",
		],
	};

	const cardBlogEN: Card = {
		title: "Blog",
		description: [
			"You want to express yourself outside of solutions formatted by social networks",
			"The blog is for you!",
		],
	};

	const cardBlog: Card = {
		title: "Blog",
		description: [
			"Vous souhaitez vous exprimer hors des solutions formattées par les réseaux sociaux",
			"Le blog est fait pour vous !",
		],
	};

	const cardHebergementEN: Card = {
		title: "Hosting",
		description: [
			"We take care of the reservation of a domain name and the relationship with a host",
			"Forget the piping!",
		],
	};

	const cardHebergement: Card = {
		title: "Hébergement",
		description: [
			"Nous prenons en charge la réservation d'un nom de domaine et la relation avec un hébergeur",
			"Oubliez la tuyauterie !",
		],
	};

	const cards: Card[] = [];
	cards.push(cardWebSite);
	cards.push(cardECommerce);
	cards.push(cardBlog);
	cards.push(cardHebergement);

	const cardsEN: Card[] = [];
	cardsEN.push(cardWebSiteEN);
	cardsEN.push(cardECommerceEN);
	cardsEN.push(cardBlogEN);
	cardsEN.push(cardHebergementEN);

	onMount(async () => {
		scrollToAnchor(anchor);
	});

	/*
	* Style : square -> deglingos -> minitel -> square ...
	*/
	function toogleStyle() {
		if ($square) {
			$square = false;
			$deglingos = true;
			$minitel = false;
		} else if ($deglingos) {
			$square = false;
			$deglingos = false;
			$minitel = true;
		} else if ($minitel) {
			$square = true;
			$deglingos = false;
			$minitel = false;
		}
	}

</script>

<style lang="scss">

	.articleWithPhoto {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		width: 100%;
		&__text {
			padding: 0 32px 0 0;
			text-align: center;
		}
		&__img {
			width: 100%;
			margin: 16px 0 0 0;
			border-radius: 4px;
			border: 1px solid $color_secondary;
			&__deglingos {
				width: 80%;
				border-radius: 63% 44% 44% 15%;
			}
			&__minitel {
				border: none;
				border-radius: 0;
			}
		}
	}

	.articleWithPear {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		align-content: center;
		width: 100%;
		&__text {
			text-align: center;
		}
		&__img {
			width: 100%;
			margin: 16px 0 0 0;
			border-radius: 4px;
			border: 1px solid $color_secondary;
			opacity: 0.8;
			&__deglingos {
				border-radius: 63% 44% 20% 106%;
			}
			&__minitel {
				border: none;
				border-radius: 0;
				opacity: 0.5;
				width: 80%;
			}
		}
	}

	.catalogue {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		width: 100%;
		margin: 32px 0 32px 0;
	}

	.originalite {
		font-family: "Original Surfer", cursive;
		cursor: pointer;
		text-decoration: underline;
	}

	.socialMedia {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}

	.socialLogo {
		margin: 0 8px 0 8px;
		&__img {
			width: 30px;
			height: 30px;
			border-radius: 50%;
			&:first-child {
				display: block;
			}
			&:last-child {
				display: none;
			}
		}
		&:hover &__img:last-child {
			display: block;
			width: 30px;
			height: 30px;
		}
		&:hover &__img:first-child {
			display: none;
		}
	}

	.contact {
		cursor: pointer;
		text-decoration: underline;
		&__strong {
			font-weight: bold;
		}
	}

	.mail {
		color: $color_secondary;
		margin: 0 0 24px 0;
		&--deglingos {
			color: $color_primary;
		}
		&--minitel {
			color: $color_minitel_blue;
		}
	}

	.mailLetter {
		display: none;
	}

	@include medium {
		.catalogue {
			flex-direction: row;
			flex-wrap: wrap;
			&__minitel {
				flex-direction: column;
			}
		}

		.articleWithPear {
			flex-direction: row;
			justify-content: space-between;
			align-items: flex-start;
			&__text {
				padding: 0 0 0 32px;
				width: 100%;
				text-align: left;
			}
			&__p {
				padding: 0 0 0 0;
			}
			&__img {
				margin: 0 0 0 0;
			}
		}
	}

	@include large {

		.catalogue {
			flex-direction: row;
			flex-wrap: wrap;
			&__minitel {
				flex-direction: column;
			}
		}

		.articleWithPhoto {
			flex-direction: row;
			justify-content: space-between;
			width: 100%;
		}

		.articleWithPear {
			flex-direction: row;
			justify-content: space-between;
			align-items: flex-start;
			&__text {
				padding: 0 0 0 32px;
				width: 100%;
				text-align: left;
			}
			&__p {
				padding: 0 0 0 0;
			}
			&__img {
				margin: 0 0 0 0;
			}
		}

		.mail {
			display: none;
		}

		.mailLetter {
			display: block;
			margin: 0 0 96px 0;
			&__minitel {
				margin: 0 0 0 0;
			}
		}
	}

</style>

<div class="pageContent">
	<section
		id="#qui"
		class="section"
		class:section__deglingos={$deglingos}
		class:section__deglingos__qui={$deglingos}
		class:section__minitel={$minitel}
	>
		<div id="#qui/">&nbsp;</div>
		<article class="article">
			<h2 class="article__h2" class:article__h2__minitel={$minitel}>
				{#if $english}
					IT Designer and Developer
				{:else}
					Concepteur-Développeur freelance
				{/if}
			</h2>
			<div class="articleWithPear">
				<div class="article__p">
					{#if $minitel}
					<img
						class="articleWithPear__img"
						class:articleWithPear__img__deglingos={$deglingos}
						class:articleWithPear__img__minitel={$minitel}
						src="../images/keyboard_pixel.png"
						alt="Keyboard"
					/>
					{:else}
					<img
						class="articleWithPear__img"
						class:articleWithPear__img__deglingos={$deglingos}
						src="../images/keyboard.svg"
						alt="Keyboard"
					/>
					{/if}
				</div>
				<div class="articleWithPear__text">
					<p class="articleWithPear__p">
						{#if $english}
							Website design and development
						{:else}
							Conception et développement de site web
						{/if}
					</p>
					<p class="articleWithPear__p">
						{#if $english}
							With 25 years of experience in business, punctuated
							by various projects, methods, technologies and
							contacts, <i>KÖRTEFA</i> offers its design and development
							services
						{:else}
							Fort d'une expérience de 25 ans en entreprise,
							jalonnée de différents projets, méthodes,
							technologies et interlocuteurs, <i>KÖRTEFA</i> propose
							ses services de conception et de développement
						{/if}
					</p>
				</div>
			</div>
		</article>
	</section>
	<section
		id="#quoi"
		class="section"
		class:section__deglingos={$deglingos}
		class:section__deglingos__quoi={$deglingos}
		class:section__minitel={$minitel}
	>
		<div id="#quoi/">&nbsp;</div>
		<article class="article">
			<h2 class="article__h2" class:article__h2__minitel={$minitel}>
				{#if $english}
					Catalog
				{:else}
					Catalogue
				{/if}
			</h2>
			<p class="article__p">
				{#if $english}
					Services and benefits offered
				{:else}
					Voici les services et les prestations proposées
				{/if}
			</p>
			<div class="catalogue" class:catalogue__minitel={$minitel}>
				{#if $english}
					<CardsComponent cards={cardsEN} />
				{:else}
					<CardsComponent {cards} />
				{/if}
			</div>
			<p class="article__p">
				{#if $english}
					Do not hesitate to <span class="contact" on:click={() => redirectTo(idPageOu)} on:keydown={() => redirectTo(idPageOu)}>contact</span> us for more information
				{:else}
					N'hésitez pas à nous <span class="contact" on:click={() => redirectTo(idPageOu)} on:keydown={() => redirectTo(idPageOu)}>contacter</span> pour avoir plus d'informations
				{/if}
			</p>
			<p class="article__p">
				{#if $english}
					And to see our <span class="contact contact__strong" on:click={() => redirectTo(idPageProjets)} on:keydown={() => redirectTo(idPageProjets)}>projects</span>
				{:else}
					Et pour voir nos <span class="contact contact__strong" on:click={() => redirectTo(idPageProjets)} on:keydown={() => redirectTo(idPageProjets)}>projets</span>
				{/if}
			</p>
		</article>
	</section>
	<section
		id="#comment"
		class="section"
		class:section__deglingos={$deglingos}
		class:section__deglingos__comment={$deglingos}
		class:section__minitel={$minitel}
	>
		<div id="#comment/">&nbsp;</div>
		<article class="article">
			<h2 class="article__h2" class:article__h2__minitel={$minitel}>
				{#if $english}
					Sustainable IT development
				{:else}
					Développement informatique durable
				{/if}
			</h2>
			<div class="articleWithPhoto">
				<div class="articleWithPhoto__text">
					<p class="article__p">
						{#if $english}
							The main idea is a <a
								class:article__a={!$minitel}
								class:article__a__minitel={$minitel}
								href="https://en.wikipedia.org/wiki/Green_computing"
								target=" _ blank "
							>
								sustainable IT development
							</a>
						{:else}
							L'idée directrice est un <a
							class:article__a={!$minitel}
							class:article__a__minitel={$minitel}
								href="https://fr.wikipedia.org/wiki/Informatique_durable#:~:text=L'informatique%20
              durable%2C%20l',%C3%A9conomique%20et%20environnementale%20du%20num%C3%A9rique."
								target="_blank"
							>
								développement informatique durable</a
							>
						{/if}
					</p>
					<p class="article__p">
						{#if $english}
							A web site must be <span class="article__green"
								>accessible</span
							>
							by all, whatever its material,
							<span class="article__green">easy</span> to use,
							<span class="article__green">sober</span> in
							resource. But without concession to the imagination,
							the
							<span
								class="originalite"
								on:click={() => toogleStyle()}
								>originality</span
							> and beauty
						{:else}
							Un site doit être <span class="article__green"
								>accessible</span
							>
							par tous, quelque soit son matériel,
							<span class="article__green">simple</span>
							d'utilisation,
							<span class="article__green">sobre</span> en
							ressource. Mais sans concession à l'imagination, l'<span
								class="originalite"
								on:click={() => toogleStyle()}
								>originalité</span
							> et la beauté
						{/if}
					</p>
					<p class="article__p">
						{#if $english}
							For this <i>KÖRTEFA</i> relies on light, stable and proven
							technologies
						{:else}
							Pour cela <i>KÖRTEFA</i> s'appuie sur des technologies
							légères, stables et éprouvées
						{/if}
					</p>
				</div>
				<div class="article__p">
					{#if $minitel}
					<img
						class="articleWithPhoto__img articleWithPhoto__img__minitel"
						src="../images/poirier_feuille_logo_minitel.png"
						alt="Arbre aux technos"
					/>
					{:else}
					<img
						class="articleWithPhoto__img"
						class:articleWithPhoto__img__deglingos={$deglingos}
						src="../images/poirier_feuille_logo.png"
						alt="Arbre aux technos"
					/>
					{/if}
				</div>
			</div>
		</article>
	</section>
	<section
		id="#ou"
		class="section"
		class:section__deglingos={$deglingos}
		class:section__deglingos__contact={$deglingos}
		class:section__minitel={$minitel}
	>
		<div id="#ou/">&nbsp;</div>
		<article class="article">
			<h2 class="article__h2" class:article__h2__minitel={$minitel}>Contact</h2>
		</article>
		<a class="mailLetter" class:mailLetter__minitel={$minitel} href="mailto:contact@kortefa.net" target="_blank">
			{#if $deglingos}
				<LetterComponentPrimary />
			{:else if $square}
				<LetterComponentSecondary />
			{:else}
				<MinitelContact />
			{/if}
		</a>
		<a
			class="mail"
			class:mail--deglingos={$deglingos}
			class:mail--minitel={$minitel}
			href="mailto:contact@kortefa.net"
			target="_blank">contact@kortefa.net
		</a>
	</section>
	<Toaster />
</div>
